import React, { Component } from 'react'
import FormInput from '../view/FormInput'
import UtilService from '../utils/utils'
import CountryCodeSelect from '../view/CountryCodeSelect';
import constant from "../../constants/constant";
import $ from 'jquery';
import { toast } from 'react-toastify';
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import ValidationMessage from '../view/ValidationMessage';

const initialAddressStateKey = {
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    state: "",
    zip: "",
    countryId: ""
}
export default class AddressForm extends Component {
    constructor(props) {
        super(props)
        //get addressValue from props
        const addressValue = this.props.addressForm
        this.state = {
            addressField: addressValue,
            submitted: false,
            errors: {},
            selectedCountry: null,
            selectedState: null,
            selectedCity: null,
        }
    }
    componentDidMount() {
        setTimeout(() => {
            this.setInitialStateData();
        }, 2000);
    }
    setInitialStateData = () => {
        const { addressField } = this.state;
        let defaultCountryName = addressField.countryId;
        let defaultStateName = addressField.state;
        let defaultCityName = addressField.city;


        if (UtilService.getCountryList() != null && defaultCountryName) {
            let parsedCountryData = JSON.parse(UtilService.getCountryList());
            const defaultCountry = this.findCountryByName(defaultCountryName || parsedCountryData.countries[0].countryName);
            this.setState({ selectedCountry: defaultCountry }, () => {
                if (defaultCountry) {
                    const defaultState = this.findStateByName(defaultCountry.isoCode, defaultStateName);
                    this.setState({ selectedState: defaultState }, () => {
                        if (defaultState) {
                            const defaultCity = this.findCityByName(defaultCountry.isoCode, defaultState.isoCode, defaultCityName);
                            this.setState({ selectedCity: defaultCity });
                        }
                    });
                }
            });
        }
    };

    findCountryByName = (countryName) => {
        const countries = Country.getAllCountries();
        return countries.find((country) => country.name === countryName);
    };

    findStateByName = (countryIsoCode, stateName) => {
        const states = State.getStatesOfCountry(countryIsoCode);
        let state = states.find((state) => state.name === stateName);
        if(state && state.name.length === "") {
            state = states.find((state) => state.name.includes(stateName));
        }
        return state;

    };

    findCityByName = (countryIsoCode, stateIsoCode, cityName) => {
        const cities = City.getCitiesOfState(countryIsoCode, stateIsoCode);
        return cities.find((city) => city.name === cityName);
    };
    address_submit = (event) => {
        event.preventDefault()

        const { addressField } = this.state;
        let error = {};

        if (!this.props.pageName && !addressField.streetAddress1) {
            error["streetAddress1"] = "Address Line 1 is Required";
        }
        else if (!addressField.countryId) {
            error["countryId"] = "Country is Required";
        }
        // else if (!this.props.pageName && !addressField.state) {
        //     error["state"] = "State is Required";
        // }
        // else if (!this.props.pageName && !addressField.city) {
        //     error["city"] = "City is Required";
        // } 
        else if (!this.props.pageName && !addressField.zip) {
            error["zip"] = "Zip is Required";
        } 
        else {
            this.addressData = {}
            let mergeValue = Object.keys(addressField).map((key, idx) => {
                this.addressData = {
                    ...this.addressData,
                    [key]: addressField[key]
                }
                return addressField[key]
            })
            this.setAddressIntoAddressBox(this.addressData)
        }

        this.setState({
            submitted: true,
            errors: error,
        });


    }
    setAddressIntoAddressBox = (addressData) => {
        this.setState({
            addressField: initialAddressStateKey,
            selectedCountry: null,
            selectedState: null,
            selectedCity: null,
            submitted: false,
            errors: {},
        }, () => { this.props.submit_address(null); this.setInitialStateData(); })
        
        if (addressData && Object.keys(addressData).length > 0) {
            let mergeValue = Object.keys(addressData).map((key, idx) => {
                return addressData[key]
            })
            this.setState({
                addressField: addressData,
            }, () => { this.props.submit_address(mergeValue.join(" "), this.state.addressField) })
        } else {
            this.setState({
                addressField: initialAddressStateKey,
                selectedCountry: null,
                selectedState: null,
                selectedCity: null,
                submitted: false,
                errors: {},
            }, () => { this.props.submit_address(null) })
        }
              $('#addressForm').modal('hide');
        if (this.props.isRegister) {
            let ele = document.getElementById('addressForm');
            ele.classList.remove('show')
            ele.style.display = 'none'
        }
    }

    changeEvent = (event) => {
        //console.log("Address Change")
        const target = event.target;
        const name = target.name;
        const value = target.value;
        const { addressField } = this.state;
        if(value.length){
            if(name === 'streetAddress1' || name === 'streetAddress2'){
                // let reg = /^[\w][\w \.\'\-\#\@\&\/]*$/;
                // if(!(reg).test(value) ){
                //     return
                // } else 
                if(value.length > 100){
                    toast.warn("The Address field can only allow up to 100 characters.")
                    return
                }
            } else if(name === 'city'){
                // let reg = /^[A-Z a-z]*$/;
                // if(!(reg).test(value) ){
                //     return
                // } else 
                if(value.length > 50){
                    toast.warn("The city field can only allow up to 50 characters.")
                    return
                }

            } else if(name === 'state'){
                let reg = /^[A-Z a-z]*$/;
                // if(!(reg).test(value) ){
                //     return
                // } else 
                if(value.length > 50){
                    toast.warn("The State field can only allow up to 50 characters.")
                    return
                }

            } else if(name === 'zip'){
                let reg = /^[A-Z a-z 0-9 \-]*$/;
                if(!(reg).test(value) ){
                    return
                } else if(value.length > 30){
                    toast.warn("The ZIP field can only allow up to 30 characters.")
                    return
                }

            }
        }
        this.setState({
            submitted: false,
            errors: {},
            addressField: {
                ...addressField,
                [name]: value
            }
        });

    }
    cancelAddress = () => {
        if (this.props.parentHistory && this.props.parentHistory.location.state && this.props.parentHistory.location.state.layoutView === 'Edit') {
            this.setState({
                addressField: this.props.addressForm,
                submitted: false,
                errors: {},
            })
            this.setAddressIntoAddressBox(this.props.addressForm)
            $('#addressForm').modal('hide');
            if (this.props.isRegister) {
                let ele = document.getElementById('addressForm');
                ele.classList.remove('show')
                ele.style.display = 'none'
            }
        } else {
            this.setAddressIntoAddressBox(this.addressData)
        }
    }

      handleCountryChange = (selectedCountry) => {
        const { addressField } = this.state;
        this.setState({
            submitted: false,
            errors: {},
            addressField: {
                ...addressField,
                countryId: selectedCountry?.name,
                city: "",
                state: ""
            }
        });

        this.setState({ selectedCountry, selectedState: null, selectedCity: null });
      };
    
      handleStateChange = (selectedState) => {
        const { addressField } = this.state;
        this.setState({
            submitted: false,
            errors: {},
            addressField: {
                ...addressField,
                state: selectedState?.name
            }
        });

        this.setState({ selectedState, selectedCity: null });
      };
    
      handleCityChange = (selectedCity) => {
        const { addressField } = this.state;
        this.setState({
            submitted: false,
            errors: {},
            addressField: {
                ...addressField,
                city: selectedCity?.name
            }
        });

        this.setState({ selectedCity });
      };
    

    render() {
        const { submitted, errors, addressField } = this.state
        const { selectedCountry, selectedState, selectedCity } = this.state;
        if (this.props.resetField) {
            addressField.city = ''
            addressField.countryId = ''
            addressField.state = ''
            addressField.streetAddress1 = ''
            addressField.streetAddress2 = ''
            addressField.zip = ''
        }

        if (this.props.addressUpdate) {
            addressField.city = this.props.addressForm.city
            addressField.countryId = this.props.addressForm.countryId
            addressField.state = this.props.addressForm.state
            addressField.streetAddress1 = this.props.addressForm.streetAddress1
            addressField.streetAddress2 = this.props.addressForm.streetAddress2
            addressField.zip = this.props.addressForm.zip
        }
        return (
            <div>
                <form className="modal modaladdressForm fade" id="addressForm" onSubmit={this.address_submit} tabIndex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="d-table w-100">
                        <div className="d-table-cell">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <h3 className="modal-title text-center" id="staticBackdropLabel">Address Details</h3>
                                    <button type="button" className="close popup-close-btn" data-dismiss="modaladdressForm" aria-label="Close" onClick={() => { this.cancelAddress() }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666"></path></svg>
                                    </button>
                                    <div className="modal-body p-0">
                                        <div className="form-group">
                                            <label>Street Address<sup className="star">*</sup> </label>
                                            <div className="position-relative  mb-3">
                                                <FormInput
                                                    type="text"
                                                    placeholder="Address Line 1"
                                                    name="streetAddress1"
                                                    handleChangeEvent={this.changeEvent}
                                                    value={addressField.streetAddress1}
                                                    submitted={submitted}
                                                    errors={errors}
                                                    autoComplete="new-password"
                                                // {...this.props}
                                                />
                                                <br />
                                                <FormInput
                                                    type="text"
                                                    placeholder="Address Line 2"
                                                    name="streetAddress2"
                                                    value={addressField.streetAddress2}
                                                    handleChangeEvent={this.changeEvent}
                                                    submitted={submitted}
                                                    errors={errors}
                                                    autoComplete="new-password"
                                                // {...this.props}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Country<sup className="star">*</sup></label>
                                            {/* <CountryCodeSelect isCountryNameSorting={true} value={addressField.countryId} className="form-control" name="countryId" selectionKey={constant.COUNTRY_NAME} onSelectChange={this.changeEvent} /> */}
                                            <Select
                                                className={`${submitted && errors["countryId"]
                                                    ? "input-error"
                                                    : ""
                                                    }`}
                                                options={Country.getAllCountries()}
                                                getOptionLabel={(options) => options.name}
                                                getOptionValue={(options) => options.name}
                                                value={selectedCountry}
                                                onChange={this.handleCountryChange}
                                                placeholder="Select Country"
                                                name="countryId"   
                                                autoComplete="new-password"                                             
                                            />
                                            {submitted && errors["countryId"] && (
                                                <div className="text-error errors position-static">{errors["countryId"]}</div>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>State/Province/County</label>
                                            <Select
                                             className={`${submitted && errors["state"]
                                             ? "input-error"
                                             : ""
                                             }`}
                                                options={State?.getStatesOfCountry(selectedCountry?.isoCode)}
                                                getOptionLabel={(options) => options.name}
                                                getOptionValue={(options) => options.name}
                                                value={selectedState}
                                                onChange={this.handleStateChange}
                                                placeholder="Select State/Province/County"
                                                name="state"
                                                autoComplete="new-password"
                                            />
                                             {submitted && errors["state"] && (
                                                <div className="text-error errors position-static">{errors["state"]}</div>
                                            )}

                                        </div>
                                        <div className="form-group">
                                            <label>City</label>
                                            <div className="position-relative">
                                                <Select
                                                 className={`${submitted && errors["city"]
                                                 ? "input-error"
                                                 : ""
                                                 }`}
                                                    options={City.getCitiesOfState(
                                                        selectedState?.countryCode,
                                                        selectedState?.isoCode
                                                    )}
                                                    getOptionLabel={(options) => options.name}
                                                    getOptionValue={(options) => options.name}
                                                    value={selectedCity}
                                                    onChange={this.handleCityChange}
                                                    placeholder="Select City"
                                                    name="city"
                                                    autoComplete="new-password"
                                                />
                                                 {submitted && errors["city"] && (
                                                <div className="text-error errors position-static">{errors["city"]}</div>
                                            )}

                                            </div>
                                        </div>

                                        <div className="form-group">
                                             <label>ZIP/postal Code <sup className="star">*</sup></label>
                                             <div className="position-relative">
                                            <FormInput
                                                type="text"
                                                placeholder="Enter ZIP/postal code"
                                                name="zip"
                                                submitted={submitted}
                                                errors={errors}
                                                value={addressField.zip}
                                                autoComplete="new-password"
                                                handleChangeEvent={(e) => {
                                                    if (constant.ALPHA_NUMERIC.test(e.target.value)) {
                                                        this.changeEvent(e);
                                                    }
                                                }
                                                }
                                            // value={addressField.zip}
                                            // {...this.props}
                                            />
                                            </div>
                                        </div>


                                    </div>
                                    <div className="modal-footer p-0 mt-4 border-none">
                                        <button type="button" className="btn cancel-btn" data-dismiss="modaladdressForm" onClick={() => { this.cancelAddress() }}>Cancel</button>
                                        <input type="submit" className="btn red-btn ml-3" value="Ok" />
                                    </div>
                                    <span className='timezone-warning'>**Please fill out the entire address to avoid a timezone mismatch. </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
